// phpcs:ignoreFile
const faq = {
  init: function () {
    faq.events();
  },

  events: function () {
    let container = $(".frequently-asked");

    if (container.length > 0) {
      container.on("click", ".frequently-asked-item", function (e) {
        let content = $(this).find(".frequently-asked-item__content");
        let parent = $(this);

        if (!content.is(e.target)) {
          if (parent.hasClass("showing")) {
            parent.removeClass("showing");
            content.slideUp("fast");
          } else {
            parent.addClass("showing");
            content.slideDown("fast");
          }
        }
      });
    }
  },
};

export default faq;
